import React from "react";
import AlertLineReportDetails from "../../../../../containers/AlertLineReport/AlertLineReportDetails";
import { AlertLineReportDTO } from "../../../../../models/alert-line-report/alert-line-report-dto";

interface Props {
  alertLineReport: AlertLineReportDTO;
}

const PreviousAlertLineReportDetails = ({ alertLineReport }: Props) => {
  return (
    <>
      <AlertLineReportDetails alertLineReport={alertLineReport} />
    </>
  );
};
export default PreviousAlertLineReportDetails;
